import * as React from 'react';

import './styles.scss';

import FlexContainer from 'global_elements/Layouts/FlexContainer';
import Paragraph from 'global_elements/Text/Paragraph';
import SingleSelect from 'global_elements/Inputs/Dropdown/SingleSelect';

import { LabeledSingleSelectProps } from 'types/inputProps';
import { FontColors, FontSizes } from 'global_elements/Text/variants';
import { DisplayVariant, AlignVariant, JustifyVariant } from 'global_elements/Layouts/FlexContainer/variants';

const LabeledSingleSelect = (props: LabeledSingleSelectProps): React.JSX.Element => {
  const labelColor = props.labelFontColor ? props.labelFontColor : FontColors.DARK_GRAY;

  return (
    <label className="labeled-single-select">
      <FlexContainer display={DisplayVariant.FLEX_ROW} align={AlignVariant.CENTER} justify={JustifyVariant.START} extraClasses="labeled-single-select__header">
        <Paragraph
          text={`${props.label}${props.error ? ` -- ${props.error}` : ''}`}
          fontColor={props.error ? FontColors.HIGH_PRIORITY : labelColor}
          fontSize={props.labelFontSize ? props.labelFontSize : FontSizes.REGULAR}
          bold
        />
        {props.showRequiredAsterisk && <Paragraph text="*" fontColor={FontColors.HIGH_PRIORITY} fontSize={props.labelFontSize ? props.labelFontSize : FontSizes.REGULAR} bold />}
      </FlexContainer>
      <SingleSelect
        styles={props.styles}
        defaultValue={props.defaultValue}
        value={props.value}
        options={props.options}
        onSelection={props.onSelection}
        onblur={props.onblur}
        testid={props.testid}
        isClearable={props.isClearable}
        isDisabled={props.isDisabled}
      />
    </label>
  );
};

export default React.memo(
  LabeledSingleSelect,
  (prevProps: Readonly<LabeledSingleSelectProps>, nextProps: Readonly<LabeledSingleSelectProps>) => prevProps.value?.value === nextProps.value?.value
    && prevProps.error === nextProps.error
    && prevProps.labelFontColor === nextProps.labelFontColor
    && prevProps.labelFontSize === nextProps.labelFontSize,
);
